<app-container class="flex justify-center container" maxWidth="516px">

  <app-card [title]="'Dodaj zdjęcie, plik'"
            [subtitle]="files.length === 0 ? 'Dodaj dokument wydatku lub jego skan (jeden lub wiele stron).'
            : 'Dodaj kolejny plik lub przejdź dalej.'"
            [sidePaddings]="'2rem'" height="700px">
    <div content>
      <div *ngIf="!documentPreviewVisible">

        <div class="flex flex-col items-center">
          <div class="add-file-circle" *ngIf="files.length === 0; else slider">
            <label for="fileButton" class="add-file-label" id="file-area" matRipple>
              <div class="add-file-content">
                <app-icon name="cloud_upload" size="60" color="#575481"></app-icon>
                <span class="description" appGtmFormEvent [eventField]="'file'" [eventForm]="formName">
            <div class="primary-text">Kliknij by dodać</div>
            <div class="secondary-text">(tylko w formacie JPG, JPEG, PNG, PDF do 5 MB)</div>
          </span>
              </div>
            </label>
          </div>

          <ng-template #slider>
            <app-document-icon-slider
              class="w-full"
              [files]="files"
              (showPreview)="documentPreviewVisible = true"
            ></app-document-icon-slider>
          </ng-template>
        </div>

        <input type="button" id="fileButton" (click)="checkPermissions(fileInput)" hidden="true" />
        <input
          type="file"
          class="not-displayed"
          appGtmFormEvent
          [eventField]="'file'"
          [eventForm]="formName"
          (change)="filesAdded($event)"
          #fileInput
        />
      </div>
      <div class="text-center w-100p" style="height: 15px; margin-top: 15px;">
        <mat-error *ngIf="error" class="pt-10 pl-2">
          <span class="error">{{ error }}</span>
        </mat-error>
      </div>
    </div>
    <div buttons class="flex flex-col">

      <button mat-button color="primary" *ngIf="files.length > 0">
        <label for="fileButton"> Dodaj kolejną stronę </label>
      </button>

      <app-new-loader-button
        class="big-button button-250 self-center"
        color="accent"
        (buttonClick)="submit()"
        [disabled]="disabled"
        [loading]="uploading"
        [customType]="LoaderButtonType.RAISED"
      >Dalej
      </app-new-loader-button>
      <button type="button" mat-button class="self-center font-bold font-medium primary-color "
              style="width: 250px;" routerLink="../">
        Wróć
      </button>
    </div>
  </app-card>
</app-container>

<app-document-preview
  *ngIf="documentPreviewVisible"
  [files]="files"
  [remove]="remove"
  (hidePreview)="documentPreviewVisible = false"
></app-document-preview>
